import PlanTabs from "./Tabs";
import ChoosePlanHeader from "./ChoosePlanHeader";
import ChoosePlanCard from "./ChoosePlanCard";
import PlanPayment from "./Payment";

const managePlansComponents = {
  PlanTabs,
  ChoosePlanHeader,
  ChoosePlanCard,
  PlanPayment
}

export default managePlansComponents